// "Danger Zone" component
import type { PropsWithChildren, ReactElement } from 'react'
import { Box, useMantineTheme } from '@mantine/core'
import { useTranslation } from '@front/model'

export const DangerZone = ({ children }: PropsWithChildren): ReactElement => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  return (
    <Box
      className='relative mt-6 border-2 border-red-500 p-4'
      style={{
        borderRadius: theme.radius.lg,
      }}
    >
      <div className='bg-body absolute -top-3 left-4 px-2 text-sm font-medium text-red-500'>{t('Danger Zone')}</div>
      <div className='space-y-4'>{children}</div>
    </Box>
  )
}
